import { render, staticRenderFns } from "./productEdit.vue?vue&type=template&id=1a9fcfa0&scoped=true"
import script from "./productEdit.vue?vue&type=script&lang=js"
export * from "./productEdit.vue?vue&type=script&lang=js"
import style0 from "./productEdit.vue?vue&type=style&index=0&id=1a9fcfa0&prod&lang=scss"
import style1 from "./productEdit.vue?vue&type=style&index=1&id=1a9fcfa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9fcfa0",
  null
  
)

export default component.exports